import { render, staticRenderFns } from "./AiReportFloatingButton.vue?vue&type=template&id=0fb2d89c"
import script from "./AiReportFloatingButton.vue?vue&type=script&lang=js"
export * from "./AiReportFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./AiReportFloatingButton.vue?vue&type=style&index=0&id=0fb2d89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports